export const shapeDrawers = {
  triangle: (ctx, half, r) => {
    const h = (Math.sqrt(3) / 2) * r;
    ctx.moveTo(half, half - h);
    ctx.lineTo(half + r, half + h / 2);
    ctx.lineTo(half - r, half + h / 2);
    ctx.closePath();
  },

  oval: (ctx, half, r) => {
    ctx.ellipse(half, half, r * 1.4, r * 0.8, 0, 0, 2 * Math.PI);
  },

  star: (ctx, half, r) => {
    const spikes = 5;
    const outer = r * 1.2;
    const inner = r * 0.5;
    for (let i = 0; i < spikes * 2; i++) {
      const angle = (Math.PI / spikes) * i - Math.PI / 2;
      const radius = i % 2 === 0 ? outer : inner;
      const x = half + radius * Math.cos(angle);
      const y = half + radius * Math.sin(angle);
      i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.closePath();
  },

  cross: (ctx, half, r) => {
    const w = r * 0.4;
    ctx.rect(half - w / 2, half - r, w, r * 2);
    ctx.rect(half - r, half - w / 2, r * 2, w);
  },

  diamond: (ctx, half, r) => {
    ctx.moveTo(half, half - r);
    ctx.lineTo(half + r, half);
    ctx.lineTo(half, half + r);
    ctx.lineTo(half - r, half);
    ctx.closePath();
  },

  square: (ctx, half, r) => {
    ctx.rect(half - r, half - r, r * 2, r * 2);
  },

  circle: (ctx, half, r) => {
    ctx.arc(half, half, r, 0, 2 * Math.PI);
  },
};

// Función para crear el efecto de pulsación con referencia al mapa
export const createPulsingShape = ({
  shape = "circle",
  color = "rgb(74, 144, 226)",
  mapInstance = null,
} = {}) => {
  const size = 80;
  const half = size / 2;

  return {
    width: size,
    height: size,
    data: new Uint8Array(size * size * 4),

    onAdd() {
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      this.context = canvas.getContext("2d", { willReadFrequently: true });
    },

    render() {
      const duration = 1500;
      const t = (performance.now() % duration) / duration;

      const innerRadius = half * 0.3;
      const outerRadius = half * 0.8 * t + innerRadius;

      const ctx = this.context;
      ctx.clearRect(0, 0, size, size);

      // --- PULSO exterior ---
      ctx.beginPath();
      ctx.arc(half, half, outerRadius, 0, Math.PI * 2);
      ctx.fillStyle = color
        .replace("rgb", "rgba")
        .replace(")", `, ${(1 - t) * 0.6})`);
      ctx.fill();

      // --- FORMA interior ---
      ctx.fillStyle = color;
      ctx.strokeStyle = "#fff";
      ctx.lineWidth = 3 + 3 * (1 - t);

      ctx.beginPath();
      (shapeDrawers[shape] || shapeDrawers.circle)(ctx, half, innerRadius);

      ctx.fill();
      ctx.stroke();

      this.data = ctx.getImageData(0, 0, size, size).data;

      if (mapInstance) mapInstance.triggerRepaint();

      return true;
    },
  };
};

// Función para crear formas estáticas
export const createStaticShape = ({
  shape = "circle",
  color = "rgb(74, 144, 226)",
  size = 80,
} = {}) => {
  const half = size / 2;

  return {
    width: size,
    height: size,
    data: new Uint8Array(size * size * 4),

    onAdd() {
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      this.context = canvas.getContext("2d", { willReadFrequently: true });
    },

    render() {
      const ctx = this.context;
      ctx.clearRect(0, 0, size, size);
      const r = 12;

      ctx.fillStyle = color;
      ctx.beginPath();
      (shapeDrawers[shape] || shapeDrawers.circle)(ctx, half, r);
      ctx.fill();
      this.data = ctx.getImageData(0, 0, size, size).data;
      return true;
    },
  };
};
